export default {
  AGENT: 'agent',
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
  MONITORING: 'monitoring',
} as const;
